export default "__VITE_ASSET__9qWq2tqE__"